import {constantsErrorMessages} from "../../../Constants";
import React, {useEffect, useMemo, useState} from "react";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import Box from "@mui/material/Box";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Input, ListItemButton, ListItemText,
    Step, StepLabel,
    Stepper,
    Tooltip,
    Typography
} from "@mui/material";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {BigImage} from "./Picture";
import {useLocation, useParams} from "react-router-dom";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import UtilityServiceOrganizationPictures from "../../../API/common/UtilityServiceOrganizationPictures";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import ButtonExit from "../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import CompositionPictures from "./CompositionPictures";
import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import ButtonBack from "../../../components/UI/button/ButtonBack";

const CompositionPicturesMedia = () => {
    const [alertData, setAlertData] = useState({});
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const {id, name} = useParams();
    const [bigImage, setBigImage] = useState(null);
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(false)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 7,
        searchData: ""
    })
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}`]?.pageSize
        const searchQuery = pagesData[`${pathname}`]?.searchQuery

        return {searchQuery, pageSize}
    }

    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        UtilityServiceOrganizationPictures.getByCompositionMediaId(id).then(function (response) {
            const data = response?.data.sort((a, b) => a.priority - b.priority);
            setData(data);
            setTableOptions((prev) => ({
                ...prev,
                searchData: searchQuery || tableOptions?.searchQuery,
                pageSize: pageSize || tableOptions?.pageSize,
                totalElements: data.length
            }))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });

    }, []);

    const handleClose = () => {
        setModal(false)
    }

    const handleSubmit = (values, handleClose) => {
        setLoading(true)
        UtilityServiceOrganizationPictures.setInCompositionMediaId(values, id)
            .then(function (response) {
                const newData = [...data, response.data].sort((a, b) => a.priority - b.priority)
                setData(newData)
                setTableOptions((prev) => ({...prev, totalElements: data.length + 1}))
                handleClose()
                handleModalAlert("Данные добавлены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            }).finally(() => setLoading(false))
    }

    const handleDelete = (row) => {
        UtilityServiceOrganizationPictures.deleteInCompositionMediaId(row.id, id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id))
                setTableOptions((prev) => ({...prev, totalElements: data.length - 1}))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Наименование', accessorKey: 'name', minSize: 700,
                Cell: ({row, cell}) => {
                    return <Tooltip arrow placement="bottom"
                                    title={row.original.name}><Box
                        sx={{
                            display: "inline-block",
                            width: "900px",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}>{cell.getValue()}</Box>
                    </Tooltip>
                }
            },
            {
                header: 'Картинка', accessorKey: 'relativeUrlSmall', minSize: 100,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return <Box sx={{
                        margin: "4px",
                        height: '100px',
                        width: "170px",
                        borderRadius: "8px",
                        backgroundImage: `url(${value})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        cursor: "pointer"
                    }}
                                onClick={() => setBigImage(row.original.relativeUrl)}/>
                },
            },
        ]
        return baseColumns;

    }, [data]);

    const menuItem = [{type: "delete", text: "Удалить", handler: handleDelete}]
    return <Box sx={{width: '1200px', padding: "0 30px"}}>
        <BreadcrumbsComponent
            page={`Набор медиа ${name}`}
            path={[{name: "Главная", href: "/"}, {name: "Настройки", href: "/settings"}]}/>

        <Box
            sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "30px"}}
        >
            <Typography sx={{
                fontSize: "24px",
                fontWeight: 700,
                lineHeight: 1
            }}>{`Набор медиа ${name}`}</Typography>
            <ButtonCreate
                text={"Добавить"}
                width={130}
                onClick={() => setModal(true)}
            /></Box>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTableContainerProps={{
                sx: {
                    width: '1200px',
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": {
                        padding: 0,
                        width: "50px",
                        height: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                        },
                        '&:nth-of-type(even)': {
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={data}
            onGlobalFilterChange={value => tableOptionsHandle({...tableOptions, searchData: value})}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            state={{showGlobalFilter: true, pagination: tableOptions}}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })}
            localization={MRT_Localization_RU}
            enableRowActions={true}
            enableToolbarInternalActions={false}
        />
        {modal && <AddPicturesModal
            title={"Добавить"}
            open={modal} onClose={handleClose}
            handleSubmit={handleSubmit}
            loading={loading}
            handleModalAlert={handleModalAlert}
        />}
        <BigImage bigImage={bigImage} setBigImage={setBigImage}></BigImage>
        <ModalAlert
            data={alertData}
            onClose={() => setAlertData((alert) => {
                return {
                    ...alert,
                    open: false
                }
            })}/>
    </Box>
}
const AddPicturesModal = ({
                              open,
                              onClose,
                              handleSubmit,
                              title,
                              loading,
                              handleModalAlert
                          }) => {
    const [activeStep, setActiveStep] = useState(0)
    const [formState, setFormState] = useState({selectedString: {}, priority: ""})
    const [validationState, setValidationState] = useState({name: ""})

    useEffect(() => {
        setFormState({selectedString: {}, priority: ""})
    }, [open])

    const handleClose = () => {
        onClose()
        setActiveStep(0)
        setFormState({selectedString: {}, priority: ""})
    }
    const handleValidationData = () => {
        const newErrors = {...validationState}
        Object.entries(formState).forEach(([name, value]) => {
            if (value === "" && name === "priority") {
                newErrors[name] = "пустое поле"
            }
        })
        setValidationState(newErrors)
        if (Object.values(newErrors).every(el => el === "")) {
            handleSubmit(formState, handleClose)
        }
    }
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: activeStep === 0 ? "1200px" : `630px`,
            }
        }}> <Box style={{
            padding: 20,
            display: "flex",
            flexDirection: "column",
            gap: 16,
            justifyContent: "space-between",
            alignItems: "center"
        }}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <Stepper
                style={{width: 446}}
                activeStep={activeStep}
            >
                {["Картинки", "Приоритет"].map((label) => (
                    <Step key={label}>
                        <StepLabel sx={{
                            ".MuiSvgIcon-root": {
                                fontSize: 40,
                                color: "#737478",
                                "&.Mui-active": {
                                    color: "#3B8BEC",
                                }
                            },
                            "& .MuiStepLabel-label": {
                                fontSize: 18,
                                "&.Mui-active": {
                                    fontWeight: 700,
                                }
                            }
                        }}>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Box>
            <DialogContent>
                {activeStep === 0 ?
                    <CompositionPictures
                        isModal={true} handleModalAlert={handleModalAlert}
                        selectedStringId={formState.selectedString?.id}
                        setSelectedString={(row) => setFormState(el => ({
                            ...el,
                            selectedString: row
                        }))}/>
                    :
                    <TextFieldValidation
                        name={"priority"}
                        value={formState?.priority}
                        label="Приоритет"
                        setCurrValues={setFormState}
                        type={"number"}
                        validationError={validationState?.priority}
                        setValidationState={setValidationState}
                    />
                }
            </DialogContent>
            <DialogActions style={{padding: 20, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 &&
                    <ButtonBack text={"Назад"} onClick={() => setActiveStep(0)}/>} </Box>
                <Box>
                    <ButtonExit text={"Закрыть"} onClick={handleClose}/>
                    <ButtonAdd loading={loading} text={activeStep === 0 ? "Выбрать" : "Добавить"}
                               onClick={() => activeStep === 0 ? setActiveStep(1) : handleValidationData()}
                               disabled={!formState.selectedString?.id}/>
                </Box>
            </DialogActions>
        </Dialog>
    );
}
export default CompositionPicturesMedia